import { __extends } from "tslib";
import { AbstractionBase } from '@awayjs/core';
/**
 * @class away.partition.EntityNode
 */
var EntityNode = /** @class */ (function (_super) {
    __extends(EntityNode, _super);
    function EntityNode(entity, partition) {
        return _super.call(this, entity, partition) || this;
    }
    Object.defineProperty(EntityNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "entity", {
        get: function () {
            return this._asset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "partition", {
        get: function () {
            return this._pool;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "boundsVisible", {
        get: function () {
            if (this._boundsVisible != this._parent.container.boundsVisible) {
                this._boundsVisible = this._parent.container.boundsVisible;
                if (this._boundsVisible) {
                    this._boundsPrimitiveDirty = true;
                }
                else if (this._boundsPrimitive) {
                    this._boundsPrimitive.setParent(null);
                    this._boundsPrimitive = null;
                }
            }
            return this._boundsVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isCastingShadow = function () {
        return this._parent.container.castsShadows;
    };
    EntityNode.prototype.onClear = function (event) {
        this._pool.clearEntity(this);
        _super.prototype.onClear.call(this, event);
        this.clear();
    };
    EntityNode.prototype.onInvalidate = function (event) {
        this._pool.invalidateEntity(this);
        _super.prototype.onInvalidate.call(this, event);
        this.invalidate();
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    EntityNode.prototype.isInFrustum = function (_rootEntity, _planes, _numPlanes, _pickGroup) {
        if (this.isInvisible())
            return false;
        return true;
        //return this._asset.getAbstraction<PickEntity>(pickGroup)._isInFrustumInternal(rootEntity, planes, numPlanes);
    };
    EntityNode.prototype.isInvisible = function () {
        return this._parent.isInvisible();
    };
    EntityNode.prototype.getMaskId = function () {
        return this._parent.getMaskId();
    };
    EntityNode.prototype.getBoundsPrimitive = function (pickGroup) {
        if (this._boundsPrimitiveDirty) {
            this._boundsPrimitiveDirty = false;
            this._boundsPrimitive = this.parent.container
                .getBoundsPrimitive(pickGroup.getBoundsPicker(this.partition))
                .getAbstraction(this.partition);
            this._boundsPrimitive.setParent(this._parent);
        }
        return this._boundsPrimitive;
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.isIntersectingRay = function (rootEntity, globalRayPosition, globalRayDirection, pickGroup) {
        return this
            .getAbstraction(pickGroup)
            ._isIntersectingRayInternal(rootEntity, globalRayPosition, globalRayDirection);
    };
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isRenderable = function () {
        return this.parent.getColorTransform()._isRenderable();
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.acceptTraverser = function (traverser) {
        if (traverser.enterNode(this))
            traverser.applyEntity(this);
    };
    EntityNode.prototype.setParent = function (parent) {
        if (!parent)
            this.onClear(null);
        this._parent = parent;
    };
    return EntityNode;
}(AbstractionBase));
export { EntityNode };
